import { useI18n } from '@change-corgi/core-react/i18n';
import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import type { ShareAction } from 'src/app/shared/hooks/share';

import { useQRCodeShare } from './useQRCodeShare';

export function useShareYourPetitionOffline(): ModelHookResult<{
	slugOrId: string;
	displayType: QrCodeType;
	downloadType: QrCodeType;
	downloadSize: number;
	descriptionText: string;
	downloadLinkText: string;
	downloadFilename: string;
	shareAction: ShareAction<'qrcode'>;
}> {
	const { translate } = useI18n();
	const {
		data: {
			petition: { id: petitionId },
		},
	} = useStarterDashboardV2PageData();
	const shareAction = useQRCodeShare();

	return {
		data: {
			slugOrId: petitionId,
			downloadSize: 512,
			displayType: 'WEB_STARTER_DASHBOARD',
			downloadType: 'WEB_STARTER_DASHBOARD_DOWNLOAD',
			descriptionText: translate(
				'corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.qrcode_description_text',
			),
			downloadLinkText: translate(
				'corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.qrcode_download_link_text',
			),
			downloadFilename: translate(
				'corgi.petition.starter_dashboard_v2.grow_petition.share_petition_offline.qrcode_filename',
			),
			shareAction,
		},
	};
}
